(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naima-rn-reasoning-demo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rn-reasoning-demo')) {
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#rn-try-reasoning"]');
    if (!link) return;
    const heading = document.getElementById('rn-try-reasoning');
    const demo = heading && heading.closest('rn-reasoning-demo');
    if (!demo || !demo.initialized) return;
    event.preventDefault();
    event.stopPropagation();
    if (demo.panel.hidden) demo.toggle.click();
    heading.focus({preventScroll:true});
    window.scrollTo({top:Math.max(0,window.scrollY + heading.getBoundingClientRect().top - 110),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  }, true);
  customElements.define('rn-reasoning-demo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.toggle = this.querySelector('[data-toggle]');
      this.panel = this.querySelector('[data-panel]');
      this.toggle.addEventListener('click', () => {
        const expand = this.panel.hidden;
        this.panel.hidden = !expand;
        this.toggle.setAttribute('aria-expanded', String(expand));
        this.toggle.textContent = this.copy(expand ? 'collapse' : 'expand');
      });
      this.buttons = Array.from(this.querySelectorAll('[data-answer]'));
      this.reveal = this.querySelector('[data-reveal]');
      this.status = this.querySelector('[data-status]');
      this.mode = 'guide';
      this.states = {guide:{answer:null,revealed:false},companion:{answer:null,revealed:false}};
      this.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => this.setMode(button.dataset.mode)));
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const previous=this.states[this.mode].answer;
        this.states[this.mode].answer = button;
        if(this.mode === 'guide') this.choose(button);
        else if(!this.states.companion.revealed) {
          this.buttons.forEach(b => {b.classList.toggle('is-selected',b === button);b.setAttribute('aria-pressed',String(b===button));});
          const confidence=this.querySelector('[data-confidence]');
          confidence.disabled=false;
          if(previous!==button)confidence.value='';
          this.querySelector('[data-gate]').textContent='Now rate your confidence, then check your reasoning.';
        }
      }));
      this.querySelector('[data-check]').addEventListener('click', () => {
        const answer = this.states.companion.answer;
        const confidence = this.querySelector('[data-confidence]');
        const gate = this.querySelector('[data-gate]');
        if(!answer){gate.textContent='Choose an answer first.';this.buttons[0].focus();return;}
        if(!confidence.value){gate.textContent='Choose your confidence before viewing feedback.';confidence.focus();return;}
        gate.textContent='';
        this.choose(answer);
      });
      this.querySelector('[data-revisit]').addEventListener('change', event => {
        this.querySelector('[data-revisit-note]').textContent=event.target.checked?'Marked to revisit in this demo only.':'';
      });
      this.querySelectorAll('[data-cta]').forEach(cta => cta.addEventListener('click', event => {
        let target;
        const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
        try { target = Array.from(document.querySelectorAll(this.dataset.offerSelector)).find(visible); } catch (error) { target = null; }
        target = target || document.getElementById('rn-study-guide');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const focusTarget = Array.from(target.querySelectorAll('[role="button"],button,a,input:not([type="hidden"]),[tabindex],.kaching-bundles__bar-main')).find(visible) || target;
        if (!focusTarget.matches('button,a,input,[tabindex]')) focusTarget.setAttribute('tabindex','-1');
        focusTarget.focus({preventScroll:true});
        window.scrollTo({top:Math.max(0,window.scrollY + target.getBoundingClientRect().top - 110),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
    }
    copy(name) { return this.querySelector('[data-copy-' + name + ']').content.textContent.trim(); }
    setMode(mode) {
      this.mode=mode;
      this.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mode===mode)));
      this.querySelector('[data-mode-note]').textContent=mode==='guide'?'Choose an answer to see the guide’s reasoning.':'Choose an answer, rate your confidence, then check your reasoning.';
      this.querySelector('.rn-demo__instruction:not([data-mode-note])').textContent=mode==='guide'?'Choose your answer to see the reasoning.':'Select your answer before rating your confidence.';
      this.querySelector('[data-companion-controls]').hidden=mode!=='companion'||this.states.companion.revealed;
      this.querySelector('[data-confidence]').disabled=!this.states.companion.answer||this.states.companion.revealed;
      this.querySelector('[data-check]').disabled=this.states.companion.revealed;
      this.querySelector('[data-guide-close]').hidden=mode!=='guide';
      this.querySelector('[data-reflection]').hidden=mode!=='companion';
      this.classList.remove('is-revealed');
      this.reveal.hidden=true;
      this.buttons.forEach(b=>{b.disabled=false;b.classList.remove('is-correct','is-other','is-selected');b.setAttribute('aria-expanded','false');if(mode==='companion')b.setAttribute('aria-pressed',String(b===this.states.companion.answer));else b.removeAttribute('aria-pressed');b.querySelector('[data-answer-label]').textContent='';});
      const state=this.states[mode];
      if(state.revealed)this.choose(state.answer,false);
      else if(state.answer)state.answer.classList.add('is-selected');
    }
    choose(button, moveFocus=true) {
      this.states[this.mode].revealed=true;
      this.classList.add('is-revealed');
      const correct = button.dataset.answer === this.dataset.correct;
      const feedback = this.copy(correct ? 'correct' : 'other');
      this.buttons.forEach(option => {
        const isCorrect = option.dataset.answer === this.dataset.correct;
        option.classList.toggle('is-correct',isCorrect);
        option.classList.toggle('is-other',!isCorrect);
        option.setAttribute('aria-expanded','true');
        option.querySelector('[data-answer-label]').textContent = this.copy(isCorrect ? 'first' : 'later');
      });
      if(this.mode==='companion'){
        this.querySelector('[data-companion-controls]').hidden=true;
        this.querySelector('[data-error-fields]').hidden=correct;
        this.querySelector('[data-journal-title]').textContent=correct?'Explain your reasoning':'Try the reasoning journal';
        this.querySelector('[data-cue-label]').textContent=correct?'Decisive cue that guided my answer':'Decisive cue I missed';
        this.querySelector('[data-temptation-label]').textContent=correct?'Why the other option comes later':'Why my option looked attractive';
        this.buttons.forEach(b=>b.disabled=true);
        this.querySelector('[data-confidence]').disabled=true;
        this.querySelector('[data-check]').disabled=true;
        const confidence=this.querySelector('[data-confidence]').value;
        this.querySelector('[data-result-summary]').textContent=!correct?(confidence==='green'?'A high-confidence miss: review the priority clue before moving on.':'This decision needs another look. Record the clue you missed.'):(confidence==='red'?'Correct, but low confidence: revisit the explanation rather than counting a guess as mastery.':'You chose correctly. Explain the priority in your own words to check your understanding.');
      }
      this.querySelector('[data-feedback]').textContent = feedback;
      this.reveal.hidden = false;
      this.status.textContent = feedback;
      if(!moveFocus)return;
      this.reveal.focus({preventScroll:true});
      this.reveal.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'nearest'});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
